import id from './{id}';
import query from './query';
import test from './test';
import get from './get';
import post from './post';

export type PostPayload = {
  active: boolean;
  channelName: string;
  name: string;
  nodeTypeId: number;
};
export default { id, query, get, post, test };
